import { CommonHeader } from "../Common/CommonHeader";
import { Publications } from "../Publications";
import { PublishedJournal } from "../PublishedJournal";

export const Book = () => {
  return (
    <>
      <CommonHeader title={"BOOKS"}></CommonHeader>
      <div className="container p-2 my-4">
        <div className="row">
          <h3>OUR LATEST PUBLISHED journals & BOOKS</h3>
          <p className="lead">
            Research Discourse ISSN 2277-2014(Print): An International Refereed
            Research Journal, NSL/ISSN/INF/2011, DATE 04/01/2012 is a Quarterly
            (March,June,September, December & Supplement Issue), peer-reviewed,
            open-access (OA), journal Published by- South Asia Research &
            Development Institute, B. 28/70, Manas Mandir, Durgakund ,Varanasi,
            U.P., INDIA.
          </p>
          <hr className="custom-line bg-warning" />
          <PublishedJournal />
          <Publications />
        </div>
      </div>
    </>
  );
};
